export default __webpack_public_path__ + "media/titles/title_1_locale_es-61b9d89a.png";